import { REHYDRATE } from 'redux-persist/constants'

const initialState = {
  isLoading: true
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

export default appReducer
